var setNewUuid = function($fineUploader, newUuid) {
    $fineUploader.find('.qq-upload-list-selector').find('li').last().attr('data-uuid', newUuid);
};

var updateUuidData = function($fineUploader, images) {
    $fineUploader.find('.qq-upload-list-selector').find('li').each(function(index) {
        $(this).attr('data-uuid', images[index].uuid);
    });
};

var _prependFineUploaderTemplate = function() {
    if ($('.js-ci-fine-uploader').length && $('#qq-template-gallery').length < 1) {
        $('head').prepend(
            '<script type="text/template" id="qq-template-gallery">' +
                '<div class="qq-uploader-selector qq-uploader qq-gallery" qq-drop-area-text="Dateien hierher ziehen">' +
                    '<div class="qq-total-progress-bar-container-selector qq-total-progress-bar-container">' +
                        '<div role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" class="qq-total-progress-bar-selector qq-progress-bar qq-total-progress-bar"></div>' +
                    '</div>' +
                    '<div class="qq-upload-drop-area-selector qq-upload-drop-area" qq-hide-dropzone>' +
                        '<span class="qq-upload-drop-area-text-selector"></span>' +
                    '</div>' +
                    '<div class="qq-upload-button-selector btn btn-primary">' +
                        '<div>Dateien hinzufügen</div>' +
                    '</div>' +
                    '<span class="qq-drop-processing-selector qq-drop-processing">' +
                        '<span>Dateiverarbeitung läuft...</span>' +
                        '<span class="qq-drop-processing-spinner-selector qq-drop-processing-spinner"></span>' +
                    '</span>' +
                    '<ul class="qq-upload-list-selector qq-upload-list" role="region" aria-live="polite" aria-relevant="additions removals">' +
                        '<li>' +
                            '<span role="status" class="qq-upload-status-text-selector qq-upload-status-text"></span>' +
                            '<div class="qq-progress-bar-container-selector qq-progress-bar-container">' +
                                '<div role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" class="qq-progress-bar-selector qq-progress-bar"></div>' +
                            '</div>' +
                            '<span class="qq-upload-spinner-selector qq-upload-spinner"></span>' +
                            '<div class="qq-thumbnail-wrapper">' +
                                '<img class="qq-thumbnail-selector" qq-max-size="120" style="max-width: 120px; max-height: 120px;">' +
                            '</div>' +
                            '<button type="button" class="qq-upload-cancel-selector qq-upload-cancel">X</button>' +
                            '<button type="button" class="qq-upload-retry-selector qq-upload-retry">' +
                                '<span class="qq-btn qq-retry-icon" aria-label="Erneut versuchen"></span>' +
                                'Erneut versuchen' +
                            '</button>' +
                            '<div class="qq-file-info">' +
                                '<div class="qq-file-name">' +
                                    '<span class="qq-upload-file-selector qq-upload-file"></span>' +
                                    '<span class="qq-edit-filename-icon-selector qq-edit-filename-icon" aria-label="Dateiname bearbeiten"></span>' +
                                '</div>' +
                                '<input class="qq-edit-filename-selector qq-edit-filename" tabindex="0" type="text">' +
                                '<span class="qq-upload-size-selector qq-upload-size"></span>' +
                                '<button type="button" class="qq-btn qq-upload-delete-selector qq-upload-delete">' +
                                    '<span class="qq-btn qq-delete-icon" aria-label="Löschen"></span>' +
                                '</button>' +
                                '<button type="button" class="qq-btn qq-upload-pause-selector qq-upload-pause">' +
                                    '<span class="qq-btn qq-pause-icon" aria-label="Anhalten"></span>' +
                                '</button>' +
                                '<button type="button" class="qq-btn qq-upload-continue-selector qq-upload-continue">' +
                                    '<span class="qq-btn qq-continue-icon" aria-label="Fortsetzen"></span>' +
                                '</button>' +
                            '</div>' +
                        '</li>' +
                    '</ul>' +
                    '<dialog class="qq-alert-dialog-selector">' +
                        '<div class="qq-dialog-message-selector"></div>' +
                        '<div class="qq-dialog-buttons">' +
                            '<button type="button" class="qq-cancel-button-selector">Schließen</button>' +
                        '</div>' +
                    '</dialog>' +
                    '<dialog class="qq-confirm-dialog-selector">' +
                        '<div class="qq-dialog-message-selector"></div>' +
                        '<div class="qq-dialog-buttons">' +
                            '<button type="button" class="qq-cancel-button-selector">Nie</button>' +
                            '<button type="button" class="qq-ok-button-selector">Tak</button>' +
                        '</div>' +
                    '</dialog>' +
                    '<dialog class="qq-prompt-dialog-selector">' +
                        '<div class="qq-dialog-message-selector"></div>' +
                        '<input type="text">' +
                        '<div class="qq-dialog-buttons">' +
                            '<button type="button" class="qq-cancel-button-selector">Abbrechen</button>' +
                            '<button type="button" class="qq-ok-button-selector">Ok</button>' +
                        '</div>' +
                    '</dialog>' +
                '</div>' +
            '</script>'
        );
    }
};

var _componentFineUploader = function() {        
    $('.js-ci-fine-uploader').each(function() {
        var $me = $(this);
        var $fineUploader = $me.find('.ci-fine-uploader-images');
        var $errorBox = $me.find('.ci-fine-uploader-error-box');
        var $watermark = $me.find('.ci-fine-uploader-watermark');
        var $watermarkPosition = $me.find('.ci-fine-uploader-watermark-position');
       
        if ($fineUploader.length) {
            var id = $me.data('id') ? $me.data('id') : 0,
                endpointAction = $me.data('endpoint'),
                endpointGetAction = {},
                endpointDeleteAction = {},
                token = $me.data('token') ? $me.data('token') : '',
                imagetype = $me.data('imagetype') ? $me.data('imagetype') : 0,
                watermark = '', 
                watermarkPosition = '';  
            
            if ($watermark.length) {    
                watermark = $watermark.find(":selected").val();
            }
            
            if ($watermarkPosition.length) {
                watermarkPosition = $watermarkPosition.find(":selected").val();
            }
    
            var validationOptions = { 
                allowedExtensions: ['jpeg', 'jpg', 'gif', 'png'],
                allowEmpty: false,
                image: {}
            };
            if ($me.data('limit')) {
                validationOptions.itemLimit = $me.data('limit');
            }
            if ($me.data('maxsize')) {
                validationOptions.sizeLimit = $me.data('maxsize');
            }
            if ($me.data('minsize')) {
                validationOptions.minSizeLimit = $me.data('minsize');
            }
            if ($me.data('minheight')) {
                validationOptions.image.minHeight = $me.data('minheight');
            }
            if ($me.data('maxheight')) {
                validationOptions.image.maxHeight = $me.data('maxheight');
            }
            if ($me.data('minwidth')) {
                validationOptions.image.minWidth = $me.data('minwidth');
            }
            if ($me.data('maxwidth')) {
                validationOptions.image.maxWidth = $me.data('maxwidth');
            }
    
            if ($me.data('getendpoint')) {
                endpointGetAction = { endpoint: $me.data('getendpoint') + '&id=' + id + '&token=' + token + '&imagetype=' + imagetype};
            }
            
            if ($me.data('deleteendpoint')) {
                endpointDeleteAction = { enabled: true, endpoint: $me.data('deleteendpoint') + '&id=' + id + '&token=' + token + '&imagetype=' + imagetype + '&image_id=' }; 
                if ($me.data('deleteconfirmation')) {
                    endpointDeleteAction.forceConfirm = true;
                }
            }
            
            if ($me.data('firstimagelabel')) {
                var $qqTemplateCopy = $('<div></div>');
                
                $qqTemplateCopy.append($('#qq-template-gallery').html());
                $qqTemplateCopy.find('.qq-upload-list-selector li').first().attr('data-label', $me.data('firstimagelabel'));
                $('#qq-template-gallery').text($qqTemplateCopy.html());
            }
    
            var galleryUploader = new qq.FineUploader({
                element: $fineUploader.get(0),
                template: 'qq-template-gallery',
                messages: {
                    minSizeError: 'Datei {file} ist zu klein. Die Mindestgröße beträgt ' + validationOptions.minSizeLimit/1000000 + 'MB.', 
                    sizeError: 'Datei {file} ist zu groß. Die maximale Dateigröße beträgt ' + validationOptions.sizeLimit/1000000 + 'MB.',
                    minWidthImageError: 'Datei {file}. konnte nicht hochgeladen werden. Die Mindestbreite beträgt ' + validationOptions.image.minWidth + 'px.',
                    minHeightImageError: 'Datei {file}. konnte nicht hochgeladen werden. Die Mindesthöhe beträgt ' + validationOptions.image.minHeight + 'px.',
                    maxWidthImageError: 'Datei {file}. konnte nicht hochgeladen werden. Die maximale Breite beträgt ' + validationOptions.image.maxWidth + 'px.',
                    maxHeightImageError: 'Datei {file}. konnte nicht hochgeladen werden. Die maximale Höhe beträgt ' + validationOptions.image.maxWidth + 'px.',
                    tooManyItemsError: 'Das Bildlimit wurde überschritten ({itemLimit}).',
                    typeError: 'Ungültige Dateierweiterung {file}. Zulässige Erweiterungen: {extensions}.',
                    unsupportedBrowserIos8Safari: 'Fehler! Ihr Browser unterstützt keinen Foto-Upload.'
                },
                showMessage: function (message) {
                    $errorBox.html('<div class="alert alert-danger border-0 alert-dismissible"><button type="button" class="close" data-dismiss="alert"><span>&times;</span></button>'+message+'</div>');
                },
                request: {
                    endpoint: endpointAction + '&id=' + id + '&watermark=' + watermark + '&watermarkposition=' + watermarkPosition + '&token=' + token + '&imagetype=' + imagetype
                },
                session: endpointGetAction,
                deleteFile: endpointDeleteAction,
                thumbnails: {
                    placeholders: {
                        waitingPath: STATIC_DOMAIN + 'assets/client/libs/fine-uploader/placeholders/waiting-generic.png',
                        notAvailablePath: STATIC_DOMAIN + 'assets/client/libs/fine-uploader/placeholders/not_available-generic.png'
                    }
                },
                validation: validationOptions,
                callbacks: {
                    onError: function(id, name, errorReason, xhrOrXdr) {
                        $errorBox.html('<div class="alert alert-danger border-0 alert-dismissible"><button type="button" class="close" data-dismiss="alert"><span>&times;</span></button>'+errorReason+'</div>');
                    }, 
                    onComplete: function(id, name, responseJSON) {
                        if (responseJSON.success) {
                            setNewUuid($fineUploader, responseJSON.newUuid);
                        }
                    },
                    onSessionRequestComplete: function(images, success) {
                        if (success) {
                            updateUuidData($fineUploader, images);
                        }
                    }
                }
            });
    
            if ($watermark.length) {
                $watermark.on('change', function () {
                    watermark = $(this).find(":selected").val(),
                    galleryUploader.setEndpoint(endpointAction + '&id=' + id + '&watermark=' + watermark + '&watermarkposition=' + watermarkPosition + '&token=' + token + '&imagetype=' + imagetype);
                });
            }
            if ($watermarkPosition.length) {
                $watermarkPosition.on('change', function () {
                    watermarkPosition = $(this).find(":selected").val(),
                    galleryUploader.setEndpoint(endpointAction + '&id=' + id + '&watermark=' + watermark + '&watermarkposition=' + watermarkPosition + '&token=' + token + '&imagetype=' + imagetype);
                });   
            }
            
            if ($me.data('sortendpoint')) {
                $fineUploader.find('.qq-upload-list-selector').sortable();                 
                $fineUploader.find('.qq-upload-list-selector').on('sortupdate', function(event, ui) {
                    var data = {order: []};
                    
                    $fineUploader.find('.qq-upload-list-selector').find('li').each(function() {
                        data.order.push($(this).attr('data-uuid'));
                    });
                    data.order.join(',');
                    
                    $.ajax({
                        type: "PUT",
                        url: $me.data('sortendpoint') + '&id=' + id + '&token=' + token + '&imagetype=' + imagetype,
                        data: data,
                        cache: false,
                        success: function (data) {}
                    });
                });
            }
        }
    });
};

function init() {  
    _prependFineUploaderTemplate();
    _componentFineUploader();
}

export const FineUploader = {
    init
}